
import Logo from '../../../images/logo.jpg'
import { ArrowTrendingUpIcon, ChartBarIcon, EyeIcon, XCircleIcon } from '@heroicons/react/24/outline'

export default function Example() {
  return (
    <div className="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:overflow-visible lg:px-7">
      <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="lg:max-w-lg">
            <p className="text-base font-semibold leading-7 text-yellow-600">Bienvenue chez Rokasa</p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Votre partenaire dédié à la transformation responsable des déchets textiles</h1>
              <p className="mt-6 text-xl leading-8 text-gray-700">
              Notre entreprise a été fondée avec la conviction que l'industrie textile peut être à la fois élégante et durable. Découvrez notre histoire, notre mission et notre équipe passionnée qui travaille pour un avenir plus vert.
              </p>
            </div>
          </div>
        </div>
        <div  className="-ml-12 -mt-10 p-12 hidden lg:flex lg:sticky lg:top-5 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
          <img data-aos="zoom-in"
            className="w-full max-w-none rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-full"
            src={Logo}
            alt=""
          />
        </div>
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg">
              <p>
              Découvrez notre histoire, notre mission et notre équipe passionnée qui travaille pour un avenir plus vert.
              </p>
              <ul role="list" className="mt-8 space-y-5 text-gray-700">
                <li className="flex gap-x-3">
                  <ArrowTrendingUpIcon className="mt-1 h-6 w-6 flex-none text-yellow-600" aria-hidden="true" />
                  <span>
                    <strong className="font-semibold text-gray-900">Offre : </strong> Des articles confectionnés sur base de ces tissus: Tableaux, sacs à mains, des cartables,
                    housses pour ordinateurs, accessoires de beauté etc…
                    Trie et collecte des déchets textiles
                    Apprentissage des nouvelles technique de réutilisation de déchets textiles
                  </span>
                </li>
                <li className="flex gap-x-3">
                  <EyeIcon className="mt-1 h-6 w-6 flex-none text-yellow-600" aria-hidden="true" />
                  <span>
                    <strong className="font-semibold text-gray-900">Vision : </strong> Donner une seconde vie au déchets textiles.
                  </span>
                </li>
                <li className="flex gap-x-3">
                  <XCircleIcon className="mt-1 h-6 w-6 flex-none text-yellow-600" aria-hidden="true" />
                  <span>
                    <strong className="font-semibold text-gray-900">Mission : </strong> Collecter et valoriser les déchets textiles,
                        Sensibilisation sur la gestion et la transformation des déchets,
                        Transformation des déchets textiles.
                  </span>
                </li>
                <li className="flex gap-x-3">
                  <ChartBarIcon className="mt-1 h-6 w-6 flex-none text-yellow-600" aria-hidden="true" />
                  <span>
                    <strong className="font-semibold text-gray-900">Objectifs : </strong> Contribuer à la gestion et la réduction des déchets textiles,
                  Promouvoir les articles recyclés.
                  Un déchet textile, une provision pour ROKASA.
                  </span>
                </li>
              </ul>
              <h2 className="mt-10 text-xl font-bold tracking-tight text-gray-900">ROKASA Pour un monde de la Mode Responsable.</h2>
              {/* <p className="mt-6">
                Id orci tellus laoreet id ac. Dolor, aenean leo, ac etiam consequat in. Convallis arcu ipsum urna nibh.
                Pharetra, euismod vitae interdum mauris enim, consequat vulputate nibh. Maecenas pellentesque id sed
                tellus mauris, ultrices mauris. Tincidunt enim cursus ridiculus mi. Pellentesque nam sed nullam sed diam
                turpis ipsum eu a sed convallis diam.
              </p> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
